import { useRef, useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Row,
    Col,
    CardTitle,
	
} from "reactstrap";

import Swal from 'sweetalert2'
import { useDispatch } from "react-redux";
import { connect } from "react-redux";

// import { sendEmailSubscriptionRequest } from "redux/BootcampSubscription/EmailAction";
import { sendRequestBootcampSubscription, fetchBootcampSubscription, updateBootcampSubscription } from "redux/Subscription/BootcampSubscriptionAction";

import { useHistory } from 'react-router-dom';

const BootcampSubscriptionCard = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [emailSent, setEmailSent] = useState(false);
    const [canResend, setCanResend] = useState(false);
    const [userRequestDetails, setUserRequestDetails] = useState(null);

    // Fetch subscription info when userId is available
    useEffect(() => {
        if (props.userDetails && props.userDetails.email) {
            dispatch(fetchBootcampSubscription({ userEmail: props.userDetails.email }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, props.userDetails && props.userDetails.email]);

    // Update local state when fetched data changes
    useEffect(() => {
        const fetched = props.fetchRequestBootcampSubscription && props.fetchRequestBootcampSubscription.bootcampSubscription;
        if (Array.isArray(fetched) && fetched.length) {
            const sub = fetched[0];
            setUserRequestDetails(sub);
            if (sub && sub.lastSentAt) {
                const lastSent = new Date(sub.lastSentAt);
                const now = new Date();
                const diffHours = (now - lastSent) / (1000 * 60 * 60);
                setCanResend(diffHours >= 24);
            }
        } else if (fetched && typeof fetched === 'object' && fetched.lastSentAt) {
            setUserRequestDetails(fetched);
            const lastSent = new Date(fetched.lastSentAt);
            const now = new Date();
            const diffHours = (now - lastSent) / (1000 * 60 * 60);
            setCanResend(diffHours >= 24);
        } else {
            setUserRequestDetails(null);
            setCanResend(false);
        }
    }, [props.fetchRequestBootcampSubscription]);

    useEffect(() => {
        if (props.sendRequestBootcampSubscription && props.sendRequestBootcampSubscription.loading) {
             Swal.fire({
                allowOutsideClick : false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        } else {
            if (props.sendRequestBootcampSubscription && props.sendRequestBootcampSubscription.res) {
                if(emailSent){  
                    Swal.fire('Request Sent!', 'Your request has been sent.', 'success');
                }
                if (props.userDetails && props.userDetails.email) {
                    dispatch(fetchBootcampSubscription({ userEmail: props.userDetails.email })); 
                }
            } else if (props.sendRequestBootcampSubscription && typeof props.sendRequestBootcampSubscription.error !== "undefined") {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong!' });
            }
        }
    }, [props.sendRequestBootcampSubscription, dispatch, props.userDetails]);

    // Watch update action (resend)
    useEffect(() => {
        if (props.updateBootcampSubscription && props.updateBootcampSubscription.loading) {
            Swal.fire({
                allowOutsideClick : false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        } else {
            if (props.updateBootcampSubscription && props.updateBootcampSubscription.res) {
                Swal.close();
                Swal.fire('Request Sent!', 'Your request has been sent.', 'success');
                if (props.userDetails && props.userDetails.email) {
                    dispatch(fetchBootcampSubscription({ userEmail: props.userDetails.email }));
                }
            } else if (props.updateBootcampSubscription && typeof props.updateBootcampSubscription.error !== 'undefined') {
                Swal.close();
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong!' });
        }
        }
    }, [props.updateBootcampSubscription, dispatch, props.userDetails]);

    const requestBootcampSubscription = () =>{
        Swal.fire({
            title: "Send a request?",
            text: "You want to request Bootcamp Subscription!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!"
        }).then((result) => {
            if (result.isConfirmed) {

                // Guard: ensure we have a valid userId before dispatching
                const userEmail = props && props.userDetails && props.userDetails.email;
                if (!userEmail) {
                    Swal.fire({ icon: 'error', title: 'Cannot send', text: 'User email is not available yet. Please try again after the page finishes loading.' });
                    return;
                }

                dispatch(sendRequestBootcampSubscription({ userEmail, recipient: 'dan@thepredentalconsultants.com' }));
                setEmailSent(true);
            }
        });
    };

    const resendRequestBootcampSubscription = (id) => {
            Swal.fire({
                title: "Send a request?",
                text: "You want to request Bootcamp Subscription!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!"
            }).then((result) => {
                if (result.isConfirmed) {
                    // Guard: ensure we have a valid userId before dispatching
                    const userEmail = props && props.userDetails && props.userDetails.email;
                    if (!userEmail) {
                        Swal.fire({ icon: 'error', title: 'Cannot resend', text: 'User email is not available yet. Please try again after the page finishes loading.' });
                        return;
                    }

                    dispatch(updateBootcampSubscription({ user: props.userDetails, docId: id, recipient: 'dan@thepredentalconsultants.com' }));
                    setEmailSent(true);
                }
            });

    };


    return (
        <>
            
            <Card className="card-stats mb-4 mb-xl-0 mt-3 shadow">
                <CardBody>
                    <Row>
                        <div className="col">
                            <CardTitle
                                tag="h5"
                                className="text-uppercase text-muted mb-0"
                            >
                                Bootcamp Subscription
                            </CardTitle>
    
                            {
                                (props.userDetails.ultimateAdvisingStudent === true || props.userDetails.ultimateAdvisingStudent === "true") ?
                                <>
                                    <div className="h5 font-weight-300">{props.userDetails.bootcampSubscription == 'claimed' ? 'CLAIMED' : 'UNCLAIMED'}</div>
                                    {
                                        props.userDetails.bootcampSubscription !== 'claimed' ?
                                            (emailSent || (userRequestDetails && !canResend)) ? (
                                                <>
                                                    <Button color="primary" className="mt-3" disabled title="You can send email once a day">Resend email</Button>
                                                </>
                                            ) : (userRequestDetails && canResend) ? (
                                                <>
                                                    <Button color="primary" className="mt-3" onClick={(e) => {e.preventDefault(); resendRequestBootcampSubscription(userRequestDetails.id)}} disabled={!canResend} title="You can send email once a day">Resend request</Button>
                                                </>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    className="mt-3"
                                                    onClick={(e) => { e.preventDefault(); requestBootcampSubscription(); }}
                                                    disabled={!(props && props.userDetails && props.userDetails.userId)}
                                                    title={!(props && props.userDetails && props.userDetails.userId) ? 'User data not loaded yet' : ''}
                                                >
                                                    Send request
                                                </Button>
                                            )
                                        : ''
                                    }

                                </>

                                :
                                <>
                                    <div className="h5 font-weight-300">{'NO ACCESS'}</div>
                                    <a onClick={(e) => {e.preventDefault(); history.push('/client/upgrade-uas')}} className={props.adminUser.admin ? "h4 mt-3 font-weight-bold mb-0 btn btn-danger disabled" : "h4 mt-3 font-weight-bold mb-0 btn btn-danger"}><span className="fas fa-lock text-yellow"></span>&nbsp;UPGRADE TO ULTIMATE ADVISING STUDENT</a>

                                </> 

                            }
    
                        </div>
                        <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                            <i className="fas fa-envelope"></i>
                        </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </>
        
    );
}

const mapStateToProps = state  => {
  return {
    sendEmail: state.sendEmail,
    sendRequestBootcampSubscription: state.sendRequestBootcampSubscription,
    fetchRequestBootcampSubscription: state.fetchRequestBootcampSubscription,
    updateBootcampSubscription: state.updateBootcampSubscriptionReducer,
    userDetails : state.loginAuth.userDetails,
    adminUser : state.adminUser
  }
    
}

export default connect(mapStateToProps)(BootcampSubscriptionCard);


